import SUBSCRIPTION_ACTION_TYPES from './subscription.types'

const createAction = (type, payload) => ({
  type,
  payload
})

export const setSubscriptionData = (subscriptionData) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_DATA,
    subscriptionData
  )
}
export const setSubscriptionBundle = (subscriptionBundle) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_BUNDLE,
    subscriptionBundle
  )
}

export const setSubscriptionFrequency = (subscriptionFrequency) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_FREQUENCY,
    subscriptionFrequency
  )
}

export const setSubscriptionVariants = (subscriptionVariants) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_VARIANTS,
    subscriptionVariants
  )
}

export const setSubscriptionPatterns = (productSize, patternArray) => {
  return createAction(SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_PATTERNS, {
    productSize: productSize,
    patternArray: patternArray
  })
}

export const setSubscriptionUpsells = (
  subscriptionUpgrades,
  subscriptionUpsells
) => {
  return createAction(SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_UPSELLS, {
    subscriptionUpgrades: subscriptionUpgrades,
    subscriptionUpsells: subscriptionUpsells
  })
}

export const setSubscriptionMix = (subscriptionMix) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_MIX,
    subscriptionMix
  )
}

export const setSubscriptionNavigation = (subscriptionNavigation) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_NAVIGATION,
    subscriptionNavigation
  )
}

export const setSubscriptionStep = (subscriptionStep) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_STEP,
    subscriptionStep
  )
}

export const setSubscriptionSizeSubSteps = (
  totalSubSteps,
  completedSubSteps
) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_SIZE_SUBSTEPS,
    {
      total: totalSubSteps,
      completed: completedSubSteps
    }
  )
}

export const setSubscriptionPatternSubSteps = (
  totalSubSteps,
  completedSubSteps
) => {
  return createAction(
    SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_PATTERN_SUBSTEPS,
    {
      total: totalSubSteps,
      completed: completedSubSteps
    }
  )
}

export const goToBundle = () => {
  return createAction(SUBSCRIPTION_ACTION_TYPES.GO_TO_BUNDLE)
}

export const goToSize = () => {
  return createAction(SUBSCRIPTION_ACTION_TYPES.GO_TO_SIZE)
}
